import type { AuthenticationInformation, SessionFromTokenNotFoundError } from '.'
import type { Loadable } from '../Loadable'

export type AuthenticationAppState = Readonly<{ authentication: Loadable<AuthenticationInformation, SessionFromTokenNotFoundError> }>
